import { useMemo, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { SelfieRevelationScreen } from '../../components/snapshots/revelation/SelfieRevelationScreen';
import {
  useSnapshotDetailQuery,
  useSnapshotsTimelineQuery,
} from '../../features/snapshots/queries';
import { SectionSkeleton } from '../../components/common/SectionSkeleton';
import { useQueryShellState } from '../../hooks/useQueryShellState';
import { authAPI } from '../../data/auth';
import { useAuth } from '../../store/AuthContext';
import { paths } from '../../routes/paths';

export function SelfieResult() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const onboarding = params.get('onboarding') === '1';
  const fromGuided = params.get('from') === 'guided';
  const { refreshMe } = useAuth();
  const [closing, setClosing] = useState(false);

  const { data: snapshot, isPending, isFetching } = useSnapshotDetailQuery(id);
  const snapshotShell = useQueryShellState({ data: snapshot, isPending, isFetching });
  const { data: timeline = [] } = useSnapshotsTimelineQuery();

  const orderedTimeline = useMemo(() => {
    const rows = [...timeline];
    if (snapshot && !rows.some((row) => row.id === snapshot.id)) {
      rows.push(snapshot);
    }
    return rows.sort((a, b) => {
      if (a.reference_year !== b.reference_year) {
        return a.reference_year - b.reference_year;
      }
      return a.reference_month - b.reference_month;
    });
  }, [timeline, snapshot]);

  const handleCloseCycle = async () => {
    setClosing(true);
    if (onboarding) {
      await authAPI.saveOnboardingStep('completed', true);
      await refreshMe();
      navigate(paths.dashboard, { replace: true });
      return;
    }
    if (fromGuided) {
      navigate(`${paths.dashboard}?openGuidedFlow=1`, { replace: true });
      return;
    }
    navigate(paths.selfies, {
      replace: true,
      state: { postSelfieSnapshotId: snapshot.id },
    });
  };

  if (snapshotShell.showBlockingSkeleton) {
    return <SectionSkeleton variant="hero" className="mx-auto max-w-lg" />;
  }

  if (!snapshot) return null;

  return (
    <div className="mx-auto flex min-h-[calc(100dvh-4rem)] w-full max-w-lg flex-col md:min-h-0 md:rounded-2xl md:border md:border-border md:bg-card md:px-2 md:py-4">
      <SelfieRevelationScreen
        snapshot={snapshot}
        timeline={orderedTimeline}
        onCloseCycle={handleCloseCycle}
        closing={closing}
        onboarding={onboarding}
      />
    </div>
  );
}

export default SelfieResult;
